<template>
  <div class="view checkout">
    <h1>{{ $t('form.label.checkout') }}</h1>

    <div class="layout-container">
      <div class="guest-details">
        <h2 class="guest-title">{{ $t('form.label.guest-details') }}</h2>

        <!-- Custom booking text - Customer Details(before) -->
        <div v-for="(field, index) in customTextFieldsBeforeCustomerDetails" :key="index" v-html="field.text" class="custom-text-before"></div>

        <div>
          <!-- If "Require individual guest details" is checked, show this for each guest -->

          <!-- If the field is required, set attribute required. If it's not required, set info="Optional" -->
          <div class="name-container">
            <form-input v-for="(field, index) in customerNameFields" :key="`customerNameFields_${index}`" :type="field.type" :label="field.label" :class="field.class" :info="field.info" :icon="field.icon" v-model="checkout.guest[field.model]" :required="field.required"/>
          </div>
          <form-input v-for="(field, index) in defaultCustomerFields" :key="`defaultCustomerFields_${index}`" :type="field.type" :label="field.label" :class="field.class" :info="field.info" :icon="field.icon" v-model="checkout.guest[field.model]" :required="field.required"/>

          <!-- Custom field -->
          <!-- <form-input type="text" label="Custom field - Text" icon="custom-text"/>
          <form-input type="text" label="Custom field - Date" icon="custom-date"/>
          <form-input type="checkbox" label="Custom field - Checkbox" icon="custom-checkbox"/>
          <form-input type="select" label="Custom field - Numeric dropdown" icon="custom-select"/> -->
          <form-input v-for="(field, index) in customFields" :key="`customNameFields_${index}`" :type="field.type" :label="field.label" :class="field.class" :info="field.info" :icon="field.icon" v-model="checkout.guest[field.model]" :required="!!field.required" class="long-placheholder-field"/>

          <!-- Custom booking text - Customer Details(after) -->
          <div v-for="(field, index) in customTextFieldsAfterCustomerDetails" :key="`customTextFieldsAfterCustomerDetails_${index}`" v-html="field.text" class="custom-text-after"></div>

          <div class="shipping-details" v-if="shippingFields.length > 0">
            <h2 class="shipping-title">{{ $t('form.label.shipping') }}</h2>

            <!-- Custom booking text - Shipping Info(before) -->
            <div v-for="(field, index) in customTextFieldsBeforeShippingInfo" :key="`customTextFieldsBeforeShippingInfo_${index}`" v-html="field.text" class="custom-text-before"></div>

            <form-input v-for="(field, index) in shippingFields" :key="`customerShippingFields_${index}`" :type="field.type" :label="field.label" :class="field.class" :icon="field.icon" v-model="checkout.guest[field.model]" :required="field.required"/>

            <!-- Custom booking text - Shipping Info(after) -->
            <div v-for="(field, index) in customTextFieldsAfterShippingInfo" :key="`customTextFieldsAfterShippingInfo_${index}`" v-html="field.text" class="custom-text-after"></div>
          </div>
        </div>
      </div>

      <div class="payment-details" v-if="payByCreditCard">
        <h2 class="payment-title">{{ $t('form.label.payment') }}</h2>

        <div class="cc-images">
          <img class="cc-image" src="http://pachena.zaui.com/mika/zauitour/themes/default/img/creditcard_amex.svg" title="AMEX Accepted">
          <img class="cc-image" src="http://pachena.zaui.com/mika/zauitour/themes/default/img/creditcard_visa.svg" title="VISA Accepted">
          <img class="cc-image" src="http://pachena.zaui.com/mika/zauitour/themes/default/img/creditcard_mastercard.svg" title="Master Card Accepted">
          <img class="cc-image" src="http://pachena.zaui.com/mika/zauitour/themes/default/img/creditcard_discover.svg" title="DISCOVER Accepted">
          <img class="cc-image" src="http://pachena.zaui.com/mika/zauitour/themes/default/img/creditcard_jcb.svg" title="JCB Accepted">
          <img class="cc-image" src="http://pachena.zaui.com/mika/zauitour/themes/default/img/creditcard_diners-club.svg" title="Diners Accepted">
          <img class="cc-image" src="http://pachena.zaui.com/mika/zauitour/themes/default/img/creditcard_unionpay.svg" title="Union Pay Accepted">
        </div>

        <div class="secure-badge">{{ $t('form.label.security-assurance') }}</div>

        <!-- Custom booking text - Billing Info(before) -->
        <div v-for="(field,index) in customTextFieldsBeforeBillingInfo" :key="`customTextFieldsBeforeBillingInfo_${index}`" v-html="field.text" class="custom-text-before"></div>

        <!-- Stripe -->
        <div class="cc-stripe-container" v-if="paymentGateway == 'Stripe'">
          <form-input :type="ccNumber.type" :id="ccNumber.id" :label="ccNumber.label" :icon="ccNumber.icon" :class="ccNumber.class" :required="ccNumber.required"/>
          <form-input :type="ccExpMonth.type" :id="ccExpMonth.id" :label="ccExpMonth.label" :icon="ccExpMonth.icon" :class="ccExpMonth.class" :required="ccExpMonth.required"/>
          <form-input :type="ccCVV.type" :id="ccCVV.id" :label="ccCVV.label" :icon="ccCVV.icon" :class="ccCVV.class" :required="ccCVV.required"/>
        </div>

        <div v-if="paymentGateway != 'Stripe'">
          <form-input :type="ccName.type" :label="ccName.label" :icon="ccName.icon" v-model="checkout.payment[ccName.model]" :class="ccName.class" :required="ccName.required"/>
          <form-input :type="ccNumber.type" :label="ccNumber.label" :icon="ccNumber.icon" v-model="checkout.payment[ccNumber.model]" :class="ccNumber.class" :required="ccNumber.required"/>

          <div class="cc-expiry-date-container">
            <form-input :type="ccExpMonth.type" :label="ccExpMonth.label" :icon="ccExpMonth.icon" :options="ccExpMonth.options" v-model="checkout.payment[ccExpMonth.model]" :class="ccExpMonth.class" :required="ccExpMonth.required"/>
            <form-input :type="ccExpYear.type" :label="ccExpYear.label" :icon="ccExpYear.icon" :options="ccExpYear.options" v-model="checkout.payment[ccExpYear.model]" :class="ccExpYear.class" :required="ccExpYear.required"/>
          </div>
          <form-input :type="ccCVV.type" :label="ccCVV.label" :icon="ccCVV.icon" :class="ccCVV.class" v-model="checkout.payment[ccCVV.model]" :required="ccCVV.required"/>
        </div>

        <!-- Custom booking text - Billing Info(after) -->
        <div v-for="(field, index) in customTextFieldsAfterBillingInfo" :key="`customTextFieldsAfterBillingInfo_${index}`" v-html="field.text" class="custom-text-after"></div>

        <div class="cc-additional" v-if="billingFieldsAdditional.length > 0">
          <h2 class="cc-addtional-title">{{ $t('form.label.cc.title') }}</h2>

          <!-- Custom booking text - Additional Billing Information(before) -->
          <div v-for="(field, index) in customTextFieldsBeforeAdditionalBillingInformation" :key="`customTextFieldsBeforeAdditionalBillingInformation_${index}`" v-html="field.text" class="custom-text-before"></div>

          <form-input v-for="(field, index) in billingFieldsAdditional" :key="`billingFieldsAdditional_${index}`" :type="field.type" :label="field.label" :class="field.class" :icon="field.icon" v-model="checkout.payment[field.model]" :required="field.required"/>

          <!-- Custom booking text - Additional Billing Information(after) -->
          <div v-for="(field, index) in customTextFieldsAfterAdditionalBillingInformation" :key="`customTextFieldsAfterAdditionalBillingInformation_${index}`" v-html="field.text" class="custom-text-after"></div>
        </div>

        <div class="billing-verification" v-if="billingVerificationFields.length > 0">
          <!-- Custom booking text - Billing Verification Information(before) -->
          <div v-for="(field, index) in customTextFieldsBeforeBillingVerificationInformation" :key="`customTextFieldsBeforeBillingVerificationInformation_${index}`" v-html="field.text" class="custom-text-before"></div>

          <form-input v-for="(field, index) in billingVerificationFields" :key="`billingVerificationFields_${index}`" :type="field.type" :label="field.label" :class="field.class" :icon="field.icon" v-model="checkout.payment[field.model]" :required="field.required"/>

          <!-- Custom booking text - Billing Verification Information(after) -->
          <div v-for="(field, index) in customTextFieldsAfterBillingVerificationInformation" :key="`customTextFieldsAfterBillingVerificationInformation_${index}`" v-html="field.text" class="custom-text-after"></div>
        </div>
      </div>

      <div v-if="payByVoucher" class="payment-details">
        <h2 class="voucher-title">{{ $t('form.label.voucher') }}</h2>

        <div class="voucher-company">{{ $t('agent.profile.company-organization') }}: {{ agent.company }}</div>

        <form-input type="text" :label="voucherField.label" :class="voucherField.class" icon="voucher" v-model="checkout.payment[voucherField.model]" :required="voucherField.required"/>
      </div>


      <div class="order-summary">
        <h2 class="order-summary-title">{{ $t('checkout.review') }}</h2>

        <div class="item-list">
          <div v-for="item in $cart.active.items" :key="item.$id" class="item-container">
            <cart-item  :key="item.id" :item="item" :editable="false"/>
            <div v-if="item.type == 'activity' && item.details && item.details.notes" class="note">
              <input :id="`note-toggle_${item.$id}`" class="toggle-button" type="checkbox">
              <label :for="`note-toggle_${item.$id}`">{{ $t('general.label.notes-restrictions') }}</label>
              <p v-html="item.details.notes"></p>
            </div>

            <div v-if="item.type == 'activity' && item.details && item.details.policies" class="policy">
              <input :id="`policy-toggle_${item.$id}`" class="toggle-button" type="checkbox">
              <label :for="`policy-toggle_${item.$id}`">{{ $t('general.label.cancel-policy') }}</label>
              <p v-html="item.details.policies"></p>
            </div>
          </div>

          <div class="total-price">
            <dl class="total">
              <dt>{{ $t('general.label.subtotal') }}:</dt><dd>{{$formatter.currency($cart.active.subTotal ? $cart.active.subTotal : 0)}}</dd>
              <dt v-if="promoCodeTotal > 0">{{ promoCodeLabel }}:</dt><dd v-if="promoCodeTotal > 0" class="discount-price">({{$formatter.currency(promoCodeTotal)}})</dd>
              <dt v-if="giftCertTotal > 0">{{ giftCertLabel }}:</dt><dd v-if="giftCertTotal > 0" class="discount-price">({{$formatter.currency(giftCertTotal)}})</dd>
              <dt>{{ $t('general.label.taxes') }}:</dt><dd>{{$formatter.currency($cart.active.taxes ? $cart.active.taxes : 0)}}</dd>
              <dt v-if="$cart.active.surcharge">{{ $cart.active.surcharge.name }}:</dt><dd v-if="$cart.active.surcharge">{{ $formatter.currency($cart.active.surcharge.amount) }}</dd>
              <dt v-if="$cart.active.guestFee">{{ $t('general.label.fees') }}:</dt><dd v-if="$cart.active.guestFee">{{$formatter.currency($cart.active.guestFee)}}</dd>
              <dt class="total-label">{{ $t('general.label.total') }}:</dt><dd class="total-amount">{{$formatter.currency($cart.active.total ? $cart.active.total : 0)}}</dd>
              <!-- <dt class="balance-label">{{ $t('general.label.balance') }}:</dt><dd class="balance-price">{{ $formatter.currency(balance) }}</dd> Not for inital release -->
            </dl>
          </div>

          <router-link class="edit-order" :to="{path: 'cart'}">{{ $t('form.label.edit-order') }}</router-link>
        </div>
      </div>


      <div class="checkout">
        <div class="error" v-if="agreementMessage" v-html="agreementMessage"></div>
        <div class="terms" v-if="showNewsLetterOptIn">
          <input type="checkbox" id="newsletter" v-model="checkout.guest.newsletter"/><label for="newsletter">{{ $t('terms.newsletter') }}</label>
        </div>
        <div class="terms" v-if="showLoyaltyProgramOptIn">
          <input type="checkbox" id="loyalty" v-model="checkout.guest.loyalty"/><label for="loyalty">{{ $t('terms.loyalty') }}</label>
        </div>
        <div class="terms" v-if="showPrivateDataSharingOptIn">
          <input type="checkbox" id="dataSharing" v-model="checkout.guest.dataSharing"/><label for="dataSharing">{{ $t('terms.data-sharing') }}</label>
        </div>
        <div class="terms">
          <input required ref="agreed" type="checkbox" id="tos"/><label for="tos"></label>
          <span>
            <i18n path="terms.term" tag="label">
              <a @click="openTermsModal('policies')">{{ $t('terms.policies') }}</a>
            </i18n>
          </span>
        </div>

        <button class="button-checkout" :disabled="isProcessing" :class="{processing : isProcessing}" @click="onCheckoutSubmit">{{ isProcessing ? $t('form.label.processing') : $t('form.label.pay-amount', {0: $formatter.currency($cart.active.outstandingBalance ? $cart.active.outstandingBalance : $cart.active.total)}) }}</button>
      </div>
      <h2 class="error">{{ message }}</h2>
    </div>

    <div class="picker-modal choice-picker" :class="{ active : modalActive }">
      <div class="overlay" @click="onCancel"></div>
      <div ref="modalTop" class="content">
        <h2>{{ modalTitle }}</h2>
        <p v-html="modalContent"></p>
        <div class="actions">
          <button class="primary" @click="onCancel">{{ $t('picker-modal.ok') }}</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FormInput from '@/components/FormInput.vue';
import PortalSettings from '@/models/PortalSettings';
import Agent from '@/models/Agent';
import Cart from '@/models/Cart';
import Payment from '@/models/Payment';
import Guest from '@/models/Guest';
import ModalMixin from '@/mixins/modal';
import CartItem from '@/components/CartItem';
import Activity from '@/models/Activity.js';

// Payment/guest details sections
const C_SECTION_CUSTOMER_DETAILS = 1;
const C_SECTION_SHIPPING_INFO = 2;
const C_SECTION_BILLING_INFO = 3;
const C_SECTION_BILLING_INFO_ADDITIONAL = 4;
const C_SECTION_BILLING_VERIFICATION_INFO = 5;
const C_SECTION_CUSTOM_FIELDS = 6;

export default {
  // props: ['type', 'id', 'date'],
  mixins: [ ModalMixin ],
  data() {
    return {
      message: "",
      modalContent: '',
      isProcessing: false,
      modalTitle: this.$t('terms.TOS'),
      breadcrumbLabel: this.$t('checkout.label'),
      stripe: undefined,
      stripeCard: undefined,
      agreementMessage: "",
      checkout: {
        guest: new Guest(),
        payment: new Payment()
      }
    }
  },

  created() {
    this.$cart.active.items.forEach((item) => {
      if (item.type == 'activity'){
        Activity.fetch(item.itemId);
      }
    });
    // load stripe script
    this.$loadScript("https://js.stripe.com/v3/").then(() => {
      // Script is loaded
      this.initializeGateway();
    }).catch(() => {
      // Failed to fetch script
    });
  },

  components: {
    CartItem,
    FormInput
  },

  computed: {
    balance() {
      // TODO: Add balance calculation based off of totals and promos/gift certs
      return this.$cart.active.total ? this.$cart.active.total : 0;
    },

    promoCodeLabel() {
      let promoCodeName = this.$cart.active.appliedPromoCodes ? this.$cart.active.appliedPromoCodes.promoCodes[0].label : '';
      return this.$t('general.label.promo-code') + ` (${ promoCodeName })`;
    },

    promoCodeTotal() {
      return this.$cart.active.appliedPromoCodes ? this.$cart.active.appliedPromoCodes.totalPromoAmount : 0;
    },

    giftCertLabel() {
      let giftCertName = this.$cart.active.appliedGiftCerts ? this.$cart.active.appliedGiftCerts.giftCerts[0].label : '';
      return this.$t('general.label.gc') + ` (${ giftCertName })`;
    },

    giftCertTotal() {
      return this.$cart.active.appliedGiftCerts ? this.$cart.active.appliedGiftCerts.totalGiftCertAmount : 0;
    },
    paymentFields() {
      return PortalSettings.get('paymentFields');
    },

    paymentGateway() {
      return PortalSettings.get('paymentGateway', "");
    },

    stripePublicKey() {
      return PortalSettings.get('stripePublicKey', "");
    },

    stripeConnectAccountId() {
      return PortalSettings.get('stripeConnectAccountId', "");
    },

    agent() {
      return Agent.active();
    },

    customerNameFields() {
      // filter every field but the first and last name
      let fields = this.paymentFields.defaultCustomerFields.filter(field => field.name === "firstName" || field.name === "lastName");

      return fields.map( (field, index) => {
        return this.getFormField(field, C_SECTION_CUSTOMER_DETAILS);
      });
    },

    defaultCustomerFields() {
      // exclude first and last name since we're displaying them separating in their own div
      let fields = this.paymentFields.defaultCustomerFields.filter(field => field.name !== "firstName" && field.name !== "lastName");

      return fields.map( (field, index) => {
        return this.getFormField(field, C_SECTION_CUSTOMER_DETAILS);
      });
    },

    customFields() {
      let toursInCart = this.$cart.active.items.map(item => item.itemId);
      let fields = this.paymentFields.customFields.filter(field => field.tours.filter(tour => toursInCart.indexOf(tour) != -1).length > 0);
      fields.forEach((field) => {
        field.model = field.fieldId
      });
      return fields;
    },

    // NOTE - these are not fields. They are just text labels
    customTextFieldsBeforeCustomerDetails() {
      return this.paymentFields.customTextFields.filter(field => field.position === "before" && field.groupName === "Customer Details");
    },

    customTextFieldsAfterCustomerDetails() {
      return this.paymentFields.customTextFields.filter(field => field.position === "after" && field.groupName === "Customer Details");
    },

    customTextFieldsBeforeShippingInfo() {
      return this.paymentFields.customTextFields.filter(field => field.position === "before" && field.groupName === "Shipping Info");
    },

    customTextFieldsAfterShippingInfo() {
      return this.paymentFields.customTextFields.filter(field => field.position === "after" && field.groupName === "Shipping Info");
    },

    customTextFieldsBeforeBillingInfo() {
      return this.paymentFields.customTextFields.filter(field => field.position === "before" && field.groupName === "Billing Info");
    },

    customTextFieldsAfterBillingInfo() {
      return this.paymentFields.customTextFields.filter(field => field.position === "after" && field.groupName === "Billing Info");
    },

    customTextFieldsBeforeAdditionalBillingInformation() {
      return this.paymentFields.customTextFields.filter(field => field.position === "before" && field.groupName === "Additional Billing Information");
    },

    customTextFieldsAfterAdditionalBillingInformation() {
      return this.paymentFields.customTextFields.filter(field => field.position === "after" && field.groupName === "Additional Billing Information");
    },

    customTextFieldsBeforeBillingVerificationInformation() {
      return this.paymentFields.customTextFields.filter(field => field.position === "before" && field.groupName === "Billing Verification Information");
    },

    customTextFieldsAfterBillingVerificationInformation() {
      return this.paymentFields.customTextFields.filter(field => field.position === "after" && field.groupName === "Billing Verification Information");
    },

    shippingFields() {
      let fields = this.paymentFields.shippingFields;

      return fields.map(function(field, index) {
        return this.getFormField(field, C_SECTION_SHIPPING_INFO);
      }, this);
    },

    voucherField() {
      let field = {name: "voucher",
                  required: "true"};

      return this.getFormField(field, '');
    },

    payByVoucher() {
      return this.agent && this.agent.isWholesaleRateType;
    },

    payByCreditCard() {
      return this.paymentFields.billingFields && this.paymentFields.billingFields.length > 0 && !this.payByVoucher;
    },

    ccName() {
      let field = this.paymentFields.billingFields.filter(field => field.name == "ccNameOnCard")[0];
      return this.getFormField(field, C_SECTION_BILLING_INFO);
    },

    ccNumber() {
      let field = this.paymentFields.billingFields.filter(field => field.name == "ccNumber")[0];
      return this.getFormField(field, C_SECTION_BILLING_INFO);
    },

    ccExpMonth() {
      let field = this.paymentFields.billingFields.filter(field => field.name == "ccExpMonth")[0];
      return this.getFormField(field, C_SECTION_BILLING_INFO);
    },

    ccExpYear() {
      let field = this.paymentFields.billingFields.filter(field => field.name == "ccExpYear")[0];
      return this.getFormField(field, C_SECTION_BILLING_INFO);
    },

    ccCVV() {
      let field = this.paymentFields.billingFields.filter(field => field.name == "ccCsv")[0];
      return this.getFormField(field, C_SECTION_BILLING_INFO);
    },

    billingFieldsAdditional() {
      let fields = this.paymentFields.billingFieldsAdditional;

      return fields.map(function(field, index) {
        return this.getFormField(field, C_SECTION_BILLING_INFO_ADDITIONAL);
      }, this);
    },

    billingVerificationFields() {
      let fields = this.paymentFields.billingVerificationFields;

      return fields.map(function(field, index) {
        return this.getFormField(field, C_SECTION_BILLING_VERIFICATION_INFO);
      }, this);
    },

    showNewsLetterOptIn() {
      return this.paymentFields.optIns.showNewsLetterOptIn;
    },

    showLoyaltyProgramOptIn() {
      return this.paymentFields.optIns.showLoyaltyProgramOptIn;
    },

    showPrivateDataSharingOptIn() {
      return this.paymentFields.optIns.showPrivateDataSharingOptIn;
    }
  },

  updated(){
    this.$refs.modalTop.scrollTop = 0;
  },

  methods: {
    openModal(title, content) {
      this.modalTitle = title;
      this.modalContent = content;

      this.activate();
    },

    openTermsModal(field){
      let title = "";
      let content = "";

      if (field === 'terms'){
        title = this.$t('terms.TOS');
        content = PortalSettings.get('termsOfService');
      } else {
        title = this.$t('terms.Policies');
        content = PortalSettings.get('policies');
      }

      this.openModal(title, content);
    },
    checkField(fields, category){
      var section = category == C_SECTION_CUSTOMER_DETAILS ? this.checkout.guest: this.checkout.payment;
      let checkFlag = true;
      fields.forEach((field, index) => {
        if (field.required && (!section[field.model] || section[field.model] == '')){
          fields[index].class += ' error';
          checkFlag = false;
        } else {
          if (fields[index].class){
            fields[index].class = fields[index].class.replace(' error', '');
          }
        }
      })
      return checkFlag;
    },
    onCheckoutSubmit() {
      var guest = this.checkout.guest;
      var payment = this.checkout.payment;
      //Verify required input
      let checkFlag = true;
      let ccFields = [];

      // Stripe has it's own way of validating credit card fields
      if (this.paymentGateway != 'Stripe') {
        ccFields = [this.ccNumber,
                    this.ccExpMonth,
                    this.ccCVV,
                    this.ccName,
                    this.ccExpYear];
      }
      let custFields = [this.customerNameFields,
                       this.defaultCustomerFields,
                       this.customFields,
                       this.shippingFields,];

      let payFields = [this.billingFieldsAdditional,
                       this.billingVerificationFields,
                       ccFields];

      // only the voucher number is required for voucher payments
      if(this.payByVoucher) {
        payFields = [];
        let voucherField = [this.voucherField];

        if(!this.checkField(voucherField, C_SECTION_BILLING_INFO)) {
          checkFlag = false;
        }
      }

      custFields.forEach(fields => {
        if (!this.checkField(fields, C_SECTION_CUSTOMER_DETAILS)) {
          checkFlag = false;
        }
      })
      payFields.forEach(fields => {
        if (!this.checkField(fields, C_SECTION_BILLING_INFO)) {
          checkFlag = false;
        }
      })
      if(!checkFlag){
          this.$forceUpdate();
          this.agreementMessage = this.$t('checkout.required-empty');
          return;
      }
      this.$forceUpdate();
      if (!this.$refs.agreed.checked){
        this.agreementMessage = this.$t('terms.agree');
        return;
      }//Verify input end
      this.agreementMessage = "";
      let localThis = this;
      this.isProcessing = true;

      this.createStripePaymentMethod().then(function(success) {
        if(success) {
          Cart.addGuest(guest).then(data => {
            Cart.complete(payment).then(result => {
              let bookingId = result.bookingId;

              if (bookingId <= 0){
                localThis.message = "Error creating booking.";
                localThis.isProcessing = false;
              } else {
                localThis.$store.commit('updateActiveCartId', null);

                // if an agent is logged in, reload their recent bookings
                if(localThis.agent) {
                  Agent.load();
                }
                Cart.load().then(() => {
                  localThis.$router.push({ name: 'confirmation', params: { bookingId: bookingId, be: result.be }});
                });
              }
            }).catch((err) => {
              if (!err.error){
                localThis.openModal(localThis.$t('alert.error'), err);
                return;
              }
              if(err.error.action && err.error.action.requires_action) {
                // action required
                localThis.handleGatewayServerResponse(err.error.action);
              } else {
                localThis.isProcessing = false;
                localThis.openModal(localThis.$t('alert.error'), err.error.message);
              }
            });
          }).catch(err => {
            localThis.isProcessing = false;
            localThis.openModal(localThis.$t('alert.error'), err.error.message);
          });
        }
      });

    },

    initializeGateway() {
      if(this.paymentGateway == "Stripe") {
        if(this.stripeConnectAccountId) {
          // eslint-disable-next-line
          this.stripe = Stripe(this.stripePublicKey, {stripeAccount: this.stripeConnectAccountId});
        } else {
          // eslint-disable-next-line
          this.stripe = Stripe(this.stripePublicKey);
        }

        // mount elements
        var elements = this.stripe.elements();
        this.stripeCard = elements.create('cardNumber');
        this.stripeCard.mount('#card-element');
        let stripeCardExp = elements.create('cardExpiry');
        stripeCardExp.mount('#card-exp-element');
        let stripeCardCvc = elements.create('cardCvc');
        stripeCardCvc.mount('#card-cvc-element');
      }
    },

    async createStripePaymentMethod() {
      let success = true;
      let localThis = this;

      if(this.paymentGateway == "Stripe") {
        success = false;

        return this.stripe.createPaymentMethod('card', this.stripeCard).then(function(result) {
          if (result.error) {
            localThis.isProcessing = false;
            // Inform the customer that there was an error.
            localThis.displayStripeError(result.error);
            success = false;
          } else {
            // set the paymentMethod
            localThis.checkout.payment.payment_method_id = result.paymentMethod.id;
            success = true;
          }

          return success;
        });
      } else {
        return success;
      }
    },

    handleGatewayServerResponse(action) {
      if(action.requires_action) {
        let localThis = this;

        // open Stripe modal
        // Use Stripe.js to handle required card action
        this.stripe.handleCardAction(action.payment_intent_client_secret).then(function(result) {
          if(result.error) {
            localThis.isProcessing = false;

            // Inform the customer that there was an error.
            localThis.displayStripeError(result.error);
            return;
          } else {
            // The card action has been handled
            // The PaymentIntent can be confirmed again on the server

            // set the paymentIntent
            localThis.checkout.payment.payment_intent_id = result.paymentIntent.id;
            localThis.checkout.payment.payment_method_id = undefined;

            // Need to process the cart again
            Cart.complete(localThis.checkout.payment).then(result => {
              let bookingId = result.bookingId;

              if (bookingId <= 0){
                localThis.message = "Error creating booking.";
                localThis.isProcessing = false;
              } else {
                localThis.$store.commit('updateActiveCartId', null);

                 // if an agent is logged in, reload their recent bookings
                if(localThis.agent) {
                  Agent.load();
                }

                Cart.load().then(() => {
                  localThis.$router.push({ name: 'confirmation', params: { bookingId: bookingId, be: result.be }});
                });
              }
            }).catch((err) => {
              localThis.isProcessing = false;
              localThis.openModal(localThis.$t('alert.error'), err.error.message);
            });
          }
        });
      }
    },

    /**
     * Displays the error returned from Stripe, or a generic error if the Stripe error contains sensitive information
     * @param error the Stripe error (contains an error 'code' and 'message')
     */
    displayStripeError(error) {
      var errorMessage = "";

      switch (error.code) {
        case "card_not_supported":
        // falls through
        case "expired_card":
        // falls through
        case "invalid_number":
        // falls through
        case "incomplete_number":
        // falls through
        case "incorrect_number":
        // falls through
        case "incomplete_expiry":
        // falls through
        case "invalid_expiry_month":
        // falls through
        case "invalid_expiry_year":
        // falls through
        case "invalid_expiry_year_past":
        // falls through
        case "incomplete_cvc":
        // falls through
        case "incorrect_cvc":
        // falls through
        case "invalid_cvc":
           errorMessage = error.message;
           break;
        default:
           // default error message for cases when the actual error message contains sensitive information
           errorMessage = this.$t('payment.error.generic');
           break;
      }

      // TODO - Display this in a more user-friendly way
      alert(errorMessage);
    },

    getFormField(field, category) {
      let type = field.type ? field.type : "text";
      let model = undefined;
      let label = "";
      let icon = "";
      let options = [];
      let sequence = field.sequence;
      let required = field.required === "true" ? true : false;
      let info = required ? "" : "Optional";
      let id = undefined;
      let cssClass = "";
      let currentYear = new Date().getFullYear();

      switch(field.name) {
        // defaultCustomerFields
        case "firstName":
          model = "firstName";
          label = this.$t('form.label.guest.first-name');
          icon = "name";
          break;
        case "lastName":
          model = "lastName";
          label = this.$t('form.label.guest.last-name');
          break;
        case "telephone":
          model = "phone";
          label = this.$t('form.label.guest.phone');
          icon = "phone";
          break;
        case "email":
          model = "email";
          label = this.$t('form.label.guest.email');
          icon = "email";
          break;
        case "roomNumber":
          model = "roomNumber";
          label = this.$t('form.label.guest.hotel-room');
          icon = "room";
          break;
        case "tbookingQuestions":
          type = "select";
          model = "hearAbout";
          label = this.$t('form.label.guest.hear-about');
          icon = "about";
          options = []; // TODO
          break;
        case "notes":
          type = "textarea";
          model = "comments";
          label = this.$t('form.label.guest.comments');
          icon = "comment";
          break;
        case "address": // customer hotel/address
          model = "hotelAddress";
          label = this.$t('form.label.guest.hotel');
          icon = "hotel";
          break;
        case "postal":
          model = "postal";
          label = this.$t('form.label.guest.postal');
          icon = "postal";
          break;
        case "shippingAddressLine1":
          model = (category === C_SECTION_CUSTOMER_DETAILS ? "address1" : "shippingAddress");
          label = this.$t('form.label.guest.address');
          icon = "address";
          break;
        case "shippingCity":
          model = (category === C_SECTION_CUSTOMER_DETAILS ? "city" : "shippingCity");
          label = this.$t('form.label.guest.city');
          icon = "city";
          break;
        case "shippingProvince":
          model = (category === C_SECTION_CUSTOMER_DETAILS ? "province" : "shippingProvince");
          label = this.$t('form.label.guest.province');
          icon = "province";
          break;
        case "country":
          model = "country";
          label = this.$t('form.label.guest.country');
          icon = "country";
          break;
        case "height":
          model = "height";
          label = this.$t('form.label.guest.height');
          icon = "height";
          cssClass = "short";
          break;
        case "weight":
          model = "weight";
          label = this.$t('form.label.guest.weight');
          icon = "weight";
          cssClass = "short";
          break;
        case "birthDate":
          model = "birthday";
          label = this.$t('form.label.guest.birthday');
          icon = "birthday";
          break;
        case "gender":
          type = "select";
          model = "gender";
          label = this.$t('form.label.guest.gender');
          icon = "gender";
          cssClass = "short";
          options = []; // TODO
          break;

        // shippingFields
        // all other shipping fields are handled above
        case "shippingPostal":
          model = "shippingPostal";
          label = this.$t('form.label.guest.postal');
          icon = "postal";
          break;

        // billingFields
        case "ccNameOnCard":
          model = "ccName";
          label = this.$t('form.label.cc.name');
          icon = "cc-name";
          break;
        case "ccNumber":
          type = "number";
          model = "ccNumber";
          label = this.$t('form.label.cc.number');
          icon = "cc-number";

          if(this.paymentGateway == "Stripe") {
            id = "card-element";
            type = "stripe-field";
          }
          break;
        case "ccExp":
          type = "text";
          model = "ccExpiry";
          label = this.$t('form.label.cc.expiry');
          icon = "cc-month";
          cssClass = "short";
          break;
        case "ccExpMonth":
          type = "select";
          model = "ccMonth";
          label = this.$t('form.label.cc.month');
          icon = "cc-month";
          options = [];

          for(let i = 1; i <= 12; ++i) {
            let month = i < 10 ? ("0" + i) : i;
            options.push({value: month, label: month});
          }

          if(this.paymentGateway == "Stripe") {
            id = "card-exp-element";
            type = "stripe-field";
            label = this.$t('form.label.cc.expiry');
            options = undefined;
          }
          break;
        case "ccExpYear":
          type = "select";
          model = "ccYear";
          label = this.$t('form.label.cc.year');
          icon = "";
          options = [];

          for(let i = currentYear; i <= currentYear + 10; ++i) {
            options.push({value: i, label: i});
          }

          break;
        case "ccCsv":
          type = "number";
          model = "ccCVV";
          label = this.$t('form.label.cc.cvv');
          icon = "cc-cvv";
          cssClass = "short";

          if(this.paymentGateway == "Stripe") {
            id = "card-cvc-element";
            type = "stripe-field";
          }
          break;

        // billingFieldsAdditional
        case "cc_address1":
          model = "address1";
          label = this.$t('form.label.cc.address1');
          icon = "address";
          break;
        case "cc_postalzip":
          model = "postal";
          label = this.$t('form.label.cc.postal');
          icon = "postal";
          break;

        // billingVerificationFields
        case "authorize_billing_firstNa":
          model = "firstName";
          label = this.$t('form.label.guest.first-name');
          icon = "name";
          break;
        case "authorize_billing_lastNam":
          model = "lastName";
          label = this.$t('form.label.guest.last-name');
          icon = "name";
          break;
        case "authorize_billing_address":
          model = "address1";
          label = this.$t('form.label.guest.address');
          icon = "address";
          break;
        case "authorize_billing_city":
          model = "city";
          label = this.$t('form.label.guest.city');
          icon = "city";
          break;
        case "authorize_billing_state":
          model = "province";
          label = this.$t('form.label.guest.province');
          icon = "province";
          break;
        case "authorize_billing_zip":
          model = "postal";
          label = this.$t('form.label.guest.postal');
          icon = "postal";
          break;
        case "authorize_billing_country":
          model = "country";
          label = this.$t('form.label.guest.country');
          icon = "country";
          break;
        case "authorize_billing_phone":
          model = "phone";
          label = this.$t('form.label.guest.phone');
          icon = "phone";
          break;

        // customFields
        // TODO

        case "voucher":
          model = "voucher";
          label = this.$t('form.label.voucher-number');
          icon = "voucher";
          break;

        default:
          label = field.label;
      }

      let fieldAttributes = {
        type: type,
        model: model,
        label: label,
        icon: icon,
        options: options,
        sequence: sequence,
        required: required,
        info: info,
        id: id,
        class: cssClass
      }

      return fieldAttributes;
    },

    getCustomFormField(field) {
      let type = "checkbox";
      let label = field.text;

      let fieldAttributes = {
        type: type,
        // model: model,
        label: label,
        // icon: icon,
        // sequence: sequence,
        // required: required
      }

      return fieldAttributes;
    }
  }
};
</script>

<style lang="scss">
.error {
  color: #DB4437;
}

.view.checkout {
  .picker-modal.choice-picker .content {
    padding: 15px;
    max-width: 500px;
  }

  @include breakpoint(medium) {
    .layout-container {
      display: grid;
      display: -ms-grid;
      grid-column-gap: 30px;
      grid-template-columns: 1fr 300px;
      -ms-grid-columns: 1fr 300px;
      grid-template-areas:
        "first right"
        "second right"
        "third right"
        "forth right"
        "fifth right";

      .guest-details {
        grid-area: first;
        -ms-grid-column: 1;
        -ms-grid-row: 1;
      }
      .shipping-details {
        grid-area: second;
        -ms-grid-column: 1;
        -ms-grid-row: 2;
      }
      .payment-details {
        grid-area: third;
        -ms-grid-column: 1;
        -ms-grid-row: 3;
      }
      .voucher-company {
        margin-bottom: 20px;
      }
      .cc-additional {
        grid-area: forth;
        -ms-grid-column: 1;
        -ms-grid-row: 4;
      }
      .checkout {
        grid-area: fifth;
        -ms-grid-column: 1;
        -ms-grid-row: 5;
      }
      .order-summary {
        grid-area: right;
        -ms-grid-column: 2;
        -ms-grid-row: 1;
      }
    }
  }

  /*  Edge */
  @supports (-ms-ime-align:auto) {
    .order-summary {
      margin-left: 20px;
    }
  }
  /*  IE */
  @media all and (-ms-high-contrast:none) {
    .order-summary {
      margin-left: 20px;
    }
  }

  .badge-primary {
    @include badge($colorGray);
  }

  .item-name {
    @include font-default;
    &::before {
      content: "-";
      margin: 0 5px;
    }
  }

  .copy-details {
    display: inline-block;
    margin-bottom: 20px;
  }

  .name-container,
  .cc-expiry-date-container {
    @include inputs-in-1row;
  }

  // form override style
  .component.form-input {
    @include form-layout-wide;
  }

  .name .icon { @include font-awesome($fa-var-user, light); }
  .email .icon { @include font-awesome($fa-var-envelope, light); }
  .phone .icon { @include font-awesome($fa-var-mobile-alt, light); }
  .address .icon { @include font-awesome($fa-var-map-marker-alt, light); }
  .city .icon { @include font-awesome($fa-var-building, light); }
  .province .icon { @include font-awesome($fa-var-city, light); }
  .postal .icon { @include font-awesome($fa-var-mailbox, light); }
  .country .icon { @include font-awesome($fa-var-globe-americas, light); }
  .hotel .icon { @include font-awesome($fa-var-hotel, light); }
  .room .icon { @include font-awesome($fa-var-door-closed, light); }
  .about .icon { @include font-awesome($fa-var-question, light); }
  .comment .icon { @include font-awesome($fa-var-comment-dots, light); }
  .height .icon { @include font-awesome($fa-var-ruler-vertical, light); }
  .weight .icon { @include font-awesome($fa-var-weight, light); }
  .birthday .icon { @include font-awesome($fa-var-birthday-cake, light); }
  .gender .icon { @include font-awesome($fa-var-venus-mars, light); }
  .custom-text .icon { @include font-awesome($fa-var-ellipsis-h, light); }
  .custom-date .icon { @include font-awesome($fa-var-calendar-alt, light); }
  .custom-checkbox .icon {
    @include font-awesome($fa-var-ellipsis-h, light);
    line-height: 20px !important;
    visibility: hidden;
  }
  .custom-select .icon { @include font-awesome($fa-var-ellipsis-h, light); }
  .cc-name .icon { @include font-awesome($fa-var-user, light); }
  .cc-number .icon { @include font-awesome($fa-var-credit-card, light); }
  .cc-month .icon { @include font-awesome($fa-var-calendar-alt, light); }
  .cc-cvv .icon { @include font-awesome($fa-var-ellipsis-h-alt, light); }
  .voucher .icon { @include font-awesome($fa-var-ellipsis-h-alt, light); }


  .shipping-details,
  .payment-details {
    @include form-border-top;
    &::before {
      @include breakpoint(medium) {
        margin: 0 0 20px 0;
        width: 100%;
      }
    }
  }

  .guest-title,
  .shipping-title,
  .payment-title {
    margin-bottom: 10px;
  }

  .order-summary-title {
    @include form-border-top;
    @include breakpoint(medium) {
      display: none;
    }
  }

  .cc-images {
    margin-bottom: 5px;
  }

  .cc-image {
    width: 38px;
    margin-right: 5px;
    margin-bottom: 6px;
  }

  .secure-badge {
    @include font-smaller;
    background-color: #12BC00;
    color: #fff;
    padding: 4px 10px;
    display: table;
    margin-bottom: 15px;

    &::before {
      @include font-awesome-pseudo($fa-var-lock-alt, light);
      margin-right: 5px;
    }
  }

  .item-list {
    background-color: $colorBgGray;
    position: sticky;
    top: 75px;

    @include breakpoint(medium) {
      .cart-item:first-child {
        border: none;
      }
    }

    .item-container {
      border-bottom: 1px solid $colorPaleGray;
    }

    .item {
      border-bottom: 1px solid $colorPaleGray;
      padding: 20px 15px;
      @include breakpoint(medium) {
        border: none;
        border-bottom: 1px solid $colorPaleGray;
      }

      .name {
        @include font-h2;
      }

      .date {
        display: inline-block;
        background-color: #ddd;
        padding: 2px 10px;
        margin-top: 5px;
      }

      .prices {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 10px;

        .price-breakdown {
          @include unlisted;
        }

        .subtotal {
          @include font-h2;
        }
      }

      // For P2P
      .p2p {
        .from::after {
          @include font-awesome-pseudo($fa-var-long-arrow-alt-right, regular);
          color: $colorGray;
          margin: 0 5px;
        }
      }
    }
  }

  .total {
    text-align: right;
    font-size: 16px;
    line-height: 24px;
    display: grid;
    grid-template-columns: auto 50%;
    color: $colorGray;
    dt {
      text-align: left;
      padding-right: 25px;
    }

    dd {
      margin: 0;
    }

    > .total-label, .total-amount {
      font-size: 20px;
      font-weight: 500;
      line-height: 33px;
      color: $colorDefault;
    }
  }

  .note,
  .policy {
    margin: 15px;
  }

  .toggle-button {
    display: none;

    + label {
      color: $colorBlue;
      align-items: center;
      cursor: pointer;
      &:hover {
        filter: brightness(1.3);
        // color: lighten($colorBlue, 10);
      }

      &::before {
        content: none;
      }

      &::after {
        @include font-awesome-pseudo($fa-var-chevron-down, light);
        margin-left: 5px;
      }
    }

    ~ p {
      margin-bottom: 0;
      max-height: 0;
      overflow: hidden;
    }

    &:checked {
      + label::after {
        transform: rotate(-180deg);
      }

      ~ p {
        max-height: 500px;
        overflow: auto;
        transition: all .2s;
        margin-top: 5px;
      }
    }
  }

  .content {
    max-height: 90%;
    overflow: scroll;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .total-price {
    border-bottom: 1px solid $colorPaleGray;
    background-color: $colorBgGray;
    padding: 0 15px;

    @include breakpoint(medium) {
      border-bottom: 1px solid $colorPaleGray;
    }

    .price {
      margin-left: 5px;
      float: right;
    }
  }

  .edit-order {
    display: block;
    padding: 15px;
    background: $colorBgGray;
    @include breakpoint(medium) {
      margin: 0;
    }

    &::before {
      @include font-awesome-pseudo($fa-var-chevron-left, light);
      margin-right: 8px;
      @include breakpoint(medium) {
        content: none;
      }
    }
  }

  .error {
    padding-bottom: 10px;
  }

  .terms {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .button-checkout {
    @include button($colorCTA, #fff);
    width: 100%;
    margin-bottom: 10px;
  }

  .custom-text-before {
    margin-bottom: 15px;
  }

  .custom-text-after {
    margin-bottom: 30px;
  }

  .long-placheholder-field label {
    max-width: calc(100% - 25px);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .processing {
    opacity: 0.60;
    cursor: not-allowed;
  }
}
</style>